/*jshint browserify: true */
'use strict';

module.exports = [
    'Arial',
    'Times New Roman',
    'Comic Sans MS',
    'Courier New',
    'Georgia',
    'Impact',
    'Trebuchet MS',
    'Verdana'
];